/* Cart drawer, ajax add, note, free-shipping progress, sharing.
   Everything degrades: with JS off the product form posts normally and the
   cart page still works, which is why the markup is a real <form>. */
(function () {
  'use strict';

  var cfg = window.themeCommerce || {};
  var money = function (cents) {
    var s = (cents / 100).toFixed(2);
    return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, s);
  };

  /* ── drawer ─────────────────────────────────────────────────────── */
  var drawer = document.getElementById('cartDrawer');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var x = drawer.querySelector('[data-cd-close]');
    if (x && x.focus) x.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
  }

  /* ── render ─────────────────────────────────────────────────────── */
  function render(cart) {
    var box = drawer && drawer.querySelector('[data-cd-items]');
    if (!box) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
    });

    if (!cart.item_count) {
      box.innerHTML = '<p class="cd-empty">' + (cfg.emptyText || '') + '</p>';
    } else {
      box.innerHTML = cart.items.map(function (it, i) {
        // cart.js hands back a full CDN url, usually already carrying ?v=.
        // The width query param is the current resizing convention; the older
        // _200x filename suffix still works but is fiddly to splice in
        // correctly around an existing query string.
        var img = it.image
          ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') +
            'width=200" alt="" width="64" height="80" loading="lazy">'
          : '<span class="cd-ph"></span>';
        var opts = (it.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return o.value; }).join(' · ');
        return '<div class="cd-item">' +
          '<a class="cd-img" href="' + it.url + '">' + img + '</a>' +
          '<div class="cd-meta">' +
            '<a class="cd-name" href="' + it.url + '">' + it.product_title + '</a>' +
            (opts ? '<p class="cd-opt">' + opts + '</p>' : '') +
            '<div class="cd-qty">' +
              '<button type="button" data-line="' + (i + 1) + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-line="' + (i + 1) + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<b class="cd-price">' + money(it.final_line_price) + '</b>' +
        '</div>';
      }).join('');
    }

    var total = drawer.querySelector('[data-cd-total]');
    if (total) total.textContent = money(cart.total_price);

    // free-shipping progress, wherever it appears
    document.querySelectorAll('[data-fship]').forEach(function (el) {
      var goal = parseInt(el.getAttribute('data-goal'), 10) || 0;
      if (!goal) return;
      var pct = Math.min(100, Math.round((cart.total_price / goal) * 100));
      var fill = el.querySelector('[data-fship-fill]');
      var text = el.querySelector('[data-fship-text]');
      if (fill) fill.style.width = pct + '%';
      if (text) {
        text.innerHTML = cart.total_price >= goal
          ? (cfg.shipReached || '')
          : (cfg.shipAway || '').replace('__AMT__', money(goal - cart.total_price));
      }
    });
  }

  function refresh() {
    return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(render);
  }

  /* ── ajax add ───────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !drawer) return;          // no drawer -> let it post normally
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    fetch(cfg.routes.cartAdd + '.js', {
      method: 'POST', body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add');
        return refresh().then(openDrawer);
      })
      .catch(function (err) {
        // a failed add must never look like a success
        form.submit === undefined ? null : window.location.assign(cfg.routes.cart);
        console.error(err);
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* ── quantity in the drawer ─────────────────────────────────────── */
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b) return;
      fetch(cfg.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: +b.getAttribute('data-line'),
                               quantity: Math.max(0, +b.getAttribute('data-to')) })
      }).then(function (r) { return r.json(); }).then(render);
    });

    /* ── note, saved as they type ─────────────────────────────────── */
    var note = drawer.querySelector('[data-cd-note]');
    if (note) {
      var t;
      note.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch(cfg.routes.cartUpdate + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          });
        }, 500);
      });
    }
  }

  /* open the drawer from the bag link rather than navigating */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open]');
    if (a && drawer) { e.preventDefault(); refresh().then(openDrawer); }
  });

  /* ── image protection ───────────────────────────────────────────
     Honest about what this is: it stops casual copying — right-click save,
     drag to desktop, long-press on mobile. It does not stop DevTools, the
     network tab, or a screenshot, and nothing on the web does. The point is
     friction plus a clear signal that the photographs are not free to take.
     Off unless the theme setting turns it on. */
  if (cfg.protectImages || cfg.blockContextMenu) {
    var guarded = function (el) {
      return el && el.closest &&
        el.closest('.pc, .gal, .stage, .rail, .situ, .cd-img, .aFig');
    };
    document.addEventListener('contextmenu', function (e) {
      // Site-wide when asked for, otherwise only the photography. Site-wide
      // also stops a customer opening a product in a new tab or copying an
      // address, so it stays a deliberate choice rather than the default.
      if (cfg.blockContextMenu) { e.preventDefault(); return; }
      if (e.target.tagName === 'IMG' && guarded(e.target)) e.preventDefault();
    });
    document.addEventListener('dragstart', function (e) {
      if (e.target.tagName === 'IMG' && guarded(e.target)) e.preventDefault();
    });
    // long-press on iOS offers Save Image from the callout
    document.addEventListener('touchstart', function (e) {
      if (e.target.tagName === 'IMG' && guarded(e.target)) {
        e.target.style.webkitTouchCallout = 'none';
      }
    }, { passive: true });
  }

  /* ── film: hover-to-reveal play ─────────────────────────────────
     The video ships without `controls` so the still reads as a photograph.
     The moment it plays we hand the native controls back — scrubbing,
     volume and fullscreen are the browser's job and it does them better
     than any custom bar would. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-film-play]');
    if (!btn) return;
    var wrap = btn.closest('.player');
    var vid = wrap && wrap.querySelector('video');
    if (!vid) return;
    vid.controls = true;
    wrap.classList.add('playing');
    var p = vid.play();
    if (p && p.catch) {
      p.catch(function () {
        // autoplay/codec refusal: leave the controls up so it is still usable
        wrap.classList.remove('playing');
      });
    }
  });

  /* ── sharing ────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-share]').forEach(function (row) {
    var url = row.getAttribute('data-url');
    var title = row.getAttribute('data-title');

    // Instagram cannot be linked to from the web at all — the device share
    // sheet is the only route, so surface it wherever it exists.
    var nat = row.querySelector('[data-share-native]');
    if (nat && navigator.share) {
      nat.hidden = false;
      nat.addEventListener('click', function () {
        navigator.share({ title: title, url: url }).catch(function () {});
      });
    }

    var copy = row.querySelector('[data-share-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var done = function () {
          var was = copy.textContent;
          copy.textContent = cfg.copied || 'Copied';
          setTimeout(function () { copy.textContent = was; }, 1600);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {});
        else {
          var i = document.createElement('input');
          i.value = url; document.body.appendChild(i); i.select();
          try { document.execCommand('copy'); done(); } catch (err) {}
          document.body.removeChild(i);
        }
      });
    }
  });
})();
